export interface VehicleType {
    value: string;
    labelId: string;
    group: string;
    translatedLabel?: string;
  }
  
  export const vehicleTypes: VehicleType[] = [
    { value: 'sedan', labelId: 'sedan', group: 'car' },
    { value: 'hatchback', labelId: 'hatchback', group: 'car' },
    { value: 'convertible', labelId: 'convertible', group: 'car' },
    { value: 'coupe', labelId: 'coupe', group: 'car' },
    { value: 'wagon', labelId: 'wagon', group: 'car' },
    { value: 'suv', labelId: 'suv', group: 'car' },
    { value: 'truck', labelId: 'truck', group: 'car' },
    { value: 'van', labelId: 'van', group: 'car' },
    { value: 'cargo-van', labelId: 'cargo-van', group: 'car' },
    { value: 'motorhome', labelId: 'motorhome', group: 'rv' },
    { value: 'campervan', labelId: 'campervan', group: 'rv' },
    { value: 'bus', labelId: 'bus', group: 'rv' },
    { value: 'travel_trailer', labelId: 'travel_trailer', group: 'rv' },
    { value: 'fifth_wheel', labelId: 'fifth_wheel', group: 'rv' },
    { value: 'popup_camper', labelId: 'popup_camper', group: 'rv' },
    { value: 'toy_hauler', labelId: 'toy_hauler', group: 'rv' },
    { value: 'other', labelId: 'other', group: 'rv' },
  ];